module.exports = new __parcel__URL__("report-user-workload.f1dbe170.svg").toString();